import { FeatureAccessControl } from "./featureaccesscontrol.model";
import { findWhere, each, find, filter} from 'underscore';

export class FeatureSet {

    public Id: number = 0;
    public Name: string = "";
    public Description: string = "";
    public IsAssocaitedWithRole: boolean;
    public Disabled: boolean;
    public FeatureAccessControlItem: FeatureAccessControl;
    public FeatureAccessControlList: Array<FeatureAccessControl> = [];
    public FeatureSetDependentList: Array<number> = [];

    constructor(fs: FeatureSet) {
        this.Id = fs.Id || 0;
        this.Description = fs.Description || "";
        this.Name = fs.Name || "";
        this.IsAssocaitedWithRole = fs.IsAssocaitedWithRole || false;
        this.FeatureSetDependentList = fs.FeatureSetDependentList || [];
        if (this.FeatureSetDependentList.length > 0) {
            this.Disabled = fs.Disabled;
        }
        else
            this.Disabled = false;
        this.FeatureAccessControlList = fs.FeatureAccessControlList || [];
        this.FeatureAccessControlItem = fs.FeatureAccessControlItem;
        this.FeatureSetDependentList = fs.FeatureSetDependentList || [];
    }

    toggleForDependentFeatureSet(featureSetList: Array<FeatureSet>) {

        var featuresWithDependencies = filter(featureSetList, (featureSet) => {
            return featureSet.FeatureSetDependentList.length > 0;
        });

        each(featuresWithDependencies, (featureSet) => {
            var result = find(featureSet.FeatureSetDependentList, (fId: number) => {
                let dependentFeatureSet = findWhere(featureSetList, { Id: fId, IsAssocaitedWithRole: true });
                if (dependentFeatureSet) {
                    featureSet.Disabled = false;
                    return true;
                }
            });
            if (!result) {
                featureSet.IsAssocaitedWithRole = false;
                featureSet.Disabled = true;
            }
        });

    }

}
